import http from '../../http';
import { SERVER_URL } from '../../config';

export const getTablesData = (params) => http.get(`${SERVER_URL}/api-main/v1/tables`, { params: { ...params } });
